"use strict";
(self.webpackChunkdemel_shopify_template = self.webpackChunkdemel_shopify_template || []).push([
    [309], {
        2539: (A, n, t) => {
            function e(A, n) {
                var t = {
                    start: function() {
                        return 0
                    },
                    center: function(A) {
                        return e(A) / 2
                    },
                    end: e
                };

                function e(A) {
                    return n - A
                }
                return {
                    measure: function(e) {
                        return "number" == typeof A ? n * Number(A) : t[A](e)
                    }
                }
            }

            function r(A) {
                return Math.abs(A)
            }

            function i(A) {
                return A ? A / r(A) : 0
            }

            function o(A, n) {
                return r(A - n)
            }

            function u(A, n) {
                for (var t = [], e = 0; e < A.length; e += n) t.push(A.slice(e, e + n));
                return t
            }

            function a(A) {
                return Object.keys(A).map(Number)
            }

            function c(A) {
                return A[s(A)]
            }

            function s(A) {
                return Math.max(0, A.length - 1)
            }

            function l(A, n) {
                var t = r(A - n);

                function e(n) {
                    return n < A
                }

                function i(A) {
                    return A > n
                }

                function o(A) {
                    return e(A) || i(A)
                }
                return {
                    length: t,
                    max: n,
                    min: A,
                    constrain: function(t) {
                        return o(t) ? e(t) ? A : n : t
                    },
                    reachedAny: o,
                    reachedMax: i,
                    reachedMin: e,
                    removeOffset: function(A) {
                        return t ? A - t * Math.ceil((A - n) / t) : A
                    }
                }
            }

            function d(A, n, t) {
                var e = l(0, A),
                    i = e.min,
                    o = e.constrain,
                    u = A + 1,
                    a = c(n);

                function c(A) {
                    return t ? r((u + A) % u) : o(A)
                }

                function s() {
                    return a
                }

                function f(A) {
                    return a = c(A), p
                }
                var p = {
                    add: function(A) {
                        return f(s() + A)
                    },
                    clone: function() {
                        return d(A, s(), t)
                    },
                    get: s,
                    set: f,
                    min: i,
                    max: A
                };
                return p
            }

            function f() {
                var A = [];
                var n = {
                    add: function(t, e, r, i) {
                        return void 0 === i && (i = !1), t.addEventListener(e, r, i), A.push((function() {
                            return t.removeEventListener(e, r, i)
                        })), n
                    },
                    removeAll: function() {
                        return A = A.filter((function(A) {
                            return A()
                        })), n
                    }
                };
                return n
            }

            function p(A) {
                var n = A;

                function t(A) {
                    return n /= A, r
                }

                function e(A) {
                    return "number" == typeof A ? A : A.get()
                }
                var r = {
                    add: function(A) {
                        return n += e(A), r
                    },
                    divide: t,
                    get: function() {
                        return n
                    },
                    multiply: function(A) {
                        return n *= A, r
                    },
                    normalize: function() {
                        return 0 !== n && t(n), r
                    },
                    set: function(A) {
                        return n = e(A), r
                    },
                    subtract: function(A) {
                        return n -= e(A), r
                    }
                };
                return r
            }

            function m(A, n, t, e, u, a, c, s, l, d, m, g, h, v, B) {
                var w = A.cross,
                    x = ["INPUT", "SELECT", "TEXTAREA"],
                    b = p(0),
                    y = f(),
                    E = f(),
                    M = {
                        mouse: 300,
                        touch: 400
                    },
                    S = {
                        mouse: 500,
                        touch: 600
                    },
                    D = u ? 5 : 16,
                    Z = 0,
                    T = 0,
                    H = !1,
                    Q = !1,
                    I = !1,
                    F = !1;

                function G(A) {
                    if (!(F = "mousedown" === A.type) || 0 === A.button) {
                        var n = o(e.get(), c.get()) >= 2,
                            r = F || !n,
                            i = ! function(A) {
                                var n = A.nodeName || "";
                                return x.indexOf(n) > -1
                            }(A.target),
                            u = n || F && i;
                        H = !0, a.pointerDown(A), b.set(e), e.set(c), d.useBaseMass().useSpeed(80),
                            function() {
                                var A = F ? document : t;
                                E.add(A, "touchmove", P).add(A, "touchend", V).add(A, "mousemove", P).add(A, "mouseup", V)
                            }(), Z = a.readPoint(A), T = a.readPoint(A, w), h.emit("pointerDown"), r && (I = !1), u && A.preventDefault()
                    }
                }

                function P(A) {
                    if (!Q && !F) {
                        if (!A.cancelable) return V(A);
                        var t = a.readPoint(A),
                            r = a.readPoint(A, w),
                            i = o(t, Z),
                            u = o(r, T);
                        if (!(Q = i > u) && !I) return V(A)
                    }
                    var c = a.pointerMove(A);
                    !I && c && (I = !0), s.start(), e.add(n.apply(c)), A.preventDefault()
                }

                function V(A) {
                    var t = m.byDistance(0, !1).index !== g.get(),
                        c = a.pointerUp(A) * (u ? S : M)[F ? "mouse" : "touch"],
                        s = function(A, n) {
                            var t = g.clone().add(-1 * i(A)),
                                e = t.get() === g.min || t.get() === g.max,
                                o = m.byDistance(A, !u).distance;
                            return u || r(A) < 20 ? o : !v && e ? .4 * o : B && n ? .5 * o : m.byIndex(t.get(), 0).distance
                        }(n.apply(c), t),
                        f = function(A, n) {
                            if (0 === A || 0 === n) return 0;
                            if (r(A) <= r(n)) return 0;
                            var t = o(r(A), r(n));
                            return r(t / A)
                        }(c, s),
                        p = o(e.get(), b.get()) >= .5,
                        w = t && f > .75,
                        x = r(c) < 20,
                        y = w ? 10 : D,
                        Z = w ? 1 + 2.5 * f : 1;
                    p && !F && (I = !0), Q = !1, H = !1, E.removeAll(), d.useSpeed(x ? 9 : y).useMass(Z), l.distance(s, !u), F = !1, h.emit("pointerUp")
                }

                function W(A) {
                    I && A.preventDefault()
                }
                return {
                    addActivationEvents: function() {
                        var A = t;
                        y.add(A, "touchmove", (function() {})).add(A, "touchend", (function() {})).add(A, "touchstart", G).add(A, "mousedown", G).add(A, "touchcancel", V).add(A, "contextmenu", V).add(A, "click", W)
                    },
                    clickAllowed: function() {
                        return !I
                    },
                    pointerDown: function() {
                        return H
                    },
                    removeAllEvents: function() {
                        y.removeAll(), E.removeAll()
                    }
                }
            }

            function g(A, n, t) {
                var e = function(A) {
                        var n = Math.pow(10, A);
                        return function(A) {
                            return Math.round(A * n) / n
                        }
                    }(2),
                    r = p(0),
                    o = p(0),
                    u = p(0),
                    a = 0,
                    c = n,
                    s = t;

                function l(A) {
                    return c = A, f
                }

                function d(A) {
                    return s = A, f
                }
                var f = {
                    direction: function() {
                        return a
                    },
                    seek: function(n) {
                        u.set(n).subtract(A);
                        var t = function(A, n, t, e, r) {
                            return e + (A - n) / (t - n) * (r - e)
                        }(u.get(), 0, 100, 0, c);
                        return a = i(u.get()), u.normalize().multiply(t).subtract(r),
                            function(A) {
                                A.divide(s), o.add(A)
                            }(u), f
                    },
                    settle: function(n) {
                        var t = n.get() - A.get(),
                            r = !e(t);
                        return r && A.set(n), r
                    },
                    update: function() {
                        r.add(o), A.add(r), o.multiply(0)
                    },
                    useBaseMass: function() {
                        return d(t)
                    },
                    useBaseSpeed: function() {
                        return l(n)
                    },
                    useMass: d,
                    useSpeed: l
                };
                return f
            }

            function h(A, n, t, e) {
                var i = !1;
                return {
                    constrain: function(o) {
                        if (!i && A.reachedAny(t.get()) && A.reachedAny(n.get())) {
                            var u = A.reachedMin(n.get()) ? "min" : "max",
                                a = r(A[u] - n.get()),
                                c = t.get() - n.get(),
                                s = Math.min(a / 50, .85);
                            t.subtract(c * s), !o && r(c) < 10 && (t.set(A.constrain(t.get())), e.useSpeed(10).useMass(3))
                        }
                    },
                    toggleActive: function(A) {
                        i = !A
                    }
                }
            }

            function v(A, n, t, e, r) {
                var i = l(-n + A, t[0]),
                    o = e.map(i.constrain);
                return {
                    snapsContained: function() {
                        if (n <= A) return [i.max];
                        if ("keepSnaps" === r) return o;
                        var t = function() {
                                var A = o[0],
                                    n = c(o),
                                    t = o.lastIndexOf(A),
                                    e = o.indexOf(n) + 1;
                                return l(t, e)
                            }(),
                            e = t.min,
                            u = t.max;
                        return o.slice(e, u)
                    }()
                }
            }

            function B(A, n, t, e, r) {
                var i = l(t.min + n.measure(.1), t.max + n.measure(.1)),
                    o = i.reachedMin,
                    u = i.reachedMax;
                return {
                    loop: function(n) {
                        if (function(A) {
                                return 1 === A ? u(e.get()) : -1 === A && o(e.get())
                            }(n)) {
                            var t = A * (-1 * n);
                            r.forEach((function(A) {
                                return A.add(t)
                            }))
                        }
                    }
                }
            }

            function w(A) {
                var n = A.max,
                    t = A.length;
                return {
                    get: function(A) {
                        return (A - n) / -t
                    }
                }
            }

            function x(A, n, t, e, i, o) {
                var a = A.startEdge,
                    s = A.endEdge,
                    l = i.map((function(A) {
                        return e[a] - A[a]
                    })).map(t.measure).map((function(A) {
                        return -r(A)
                    })),
                    d = function() {
                        var A = u(l, o).map((function(A) {
                                return A[0]
                            })),
                            e = u(i, o).map((function(A) {
                                return c(A)[s] - A[0][a]
                            })).map(t.measure).map(r).map(n.measure);
                        return A.map((function(A, n) {
                            return A + e[n]
                        }))
                    }();
                return {
                    snaps: l,
                    snapsAligned: d
                }
            }

            function b(A, n, t, e, i) {
                var o = e.reachedAny,
                    u = e.removeOffset,
                    a = e.constrain;

                function c(A, n) {
                    return r(A) < r(n) ? A : n
                }

                function s(n, e) {
                    var i = n,
                        o = n + t,
                        u = n - t;
                    return A ? e ? r(c(i, 1 === e ? o : u)) * e : c(c(i, o), u) : i
                }
                return {
                    byDistance: function(t, e) {
                        var c = i.get() + t,
                            l = function(t) {
                                var e = A ? u(t) : a(t);
                                return {
                                    index: n.map((function(A) {
                                        return A - e
                                    })).map((function(A) {
                                        return s(A, 0)
                                    })).map((function(A, n) {
                                        return {
                                            diff: A,
                                            index: n
                                        }
                                    })).sort((function(A, n) {
                                        return r(A.diff) - r(n.diff)
                                    }))[0].index,
                                    distance: e
                                }
                            }(c),
                            d = l.index,
                            f = l.distance,
                            p = !A && o(c);
                        return !e || p ? {
                            index: d,
                            distance: t
                        } : {
                            index: d,
                            distance: t + s(n[d] - f, 0)
                        }
                    },
                    byIndex: function(A, t) {
                        return {
                            index: A,
                            distance: s(n[A] - i.get(), t)
                        }
                    },
                    shortcut: s
                }
            }

            function y(A, n, t, e, r, i, o, u) {
                var c = a(e),
                    s = a(e).reverse(),
                    l = function() {
                        var A = r[0] - 1;
                        return p(f(s, A), "end")
                    }().concat(function() {
                        var A = n - r[0] - 1;
                        return p(f(c, A), "start")
                    }());

                function d(A, n) {
                    return A.reduce((function(A, n) {
                        return A - e[n]
                    }), n)
                }

                function f(A, n) {
                    return A.reduce((function(A, t) {
                        return d(A, n) > 0 ? A.concat([t]) : A
                    }), [])
                }

                function p(A, n) {
                    var e = "start" === n,
                        r = e ? -t : t,
                        u = i.findSlideBounds([r]);
                    return A.map((function(A) {
                        var n = e ? 0 : -t,
                            r = e ? t : 0,
                            i = u.filter((function(n) {
                                return n.index === A
                            }))[0][e ? "end" : "start"];
                        return {
                            point: i,
                            getTarget: function() {
                                return o.get() > i ? n : r
                            },
                            index: A,
                            location: -1
                        }
                    }))
                }
                return {
                    canLoop: function() {
                        return l.every((function(A) {
                            var t = A.index;
                            return d(c.filter((function(A) {
                                return A !== t
                            })), n) <= 0
                        }))
                    },
                    clear: function() {
                        l.forEach((function(n) {
                            var t = n.index;
                            u[t].style[A.startEdge] = ""
                        }))
                    },
                    loop: function() {
                        l.forEach((function(n) {
                            var t = n.getTarget,
                                e = n.location,
                                r = n.index,
                                i = t();
                            i !== e && (u[r].style[A.startEdge] = i + "%", n.location = i)
                        }))
                    },
                    loopPoints: l
                }
            }

            function E(A, n, t) {
                var e = "x" === A.scroll ? function(A) {
                        return "translate3d(" + A + "%,0px,0px)"
                    } : function(A) {
                        return "translate3d(0px," + A + "%,0px)"
                    },
                    r = t.style,
                    i = !1;
                return {
                    clear: function() {
                        r.transform = ""
                    },
                    to: function(A) {
                        i || (r.transform = e(n.apply(A.get())))
                    },
                    toggleActive: function(A) {
                        i = !A
                    }
                }
            }

            function M(A, n, t, i, o) {
                var u = i.align,
                    M = i.axis,
                    S = i.direction,
                    D = i.startIndex,
                    Z = i.inViewThreshold,
                    T = i.loop,
                    H = i.speed,
                    Q = i.dragFree,
                    I = i.slidesToScroll,
                    F = i.skipSnaps,
                    G = i.containScroll,
                    P = n.getBoundingClientRect(),
                    V = t.map((function(A) {
                        return A.getBoundingClientRect()
                    })),
                    W = function(A) {
                        var n = "rtl" === A ? -1 : 1;
                        return {
                            apply: function(A) {
                                return A * n
                            }
                        }
                    }(S),
                    k = function(A, n) {
                        var t = "y" === A ? "y" : "x";
                        return {
                            scroll: t,
                            cross: "y" === A ? "x" : "y",
                            startEdge: "y" === t ? "top" : "rtl" === n ? "right" : "left",
                            endEdge: "y" === t ? "bottom" : "rtl" === n ? "left" : "right",
                            measureSize: function(A) {
                                var n = A.width,
                                    e = A.height;
                                return "x" === t ? n : e
                            }
                        }
                    }(M, S),
                    N = function(A) {
                        return {
                            measure: function(n) {
                                return 0 === A ? 0 : n / A * 100
                            },
                            totalPercent: 100
                        }
                    }(k.measureSize(P)),
                    R = N.totalPercent,
                    U = e(u, R),
                    X = function(A, n, t, e, i) {
                        var o = A.measureSize,
                            u = A.startEdge,
                            a = A.endEdge,
                            l = e.map(o);
                        return {
                            slideSizes: l.map(n.measure),
                            slideSizesWithGaps: e.map((function(A, n, e) {
                                var r = n === s(e),
                                    o = window.getComputedStyle(c(t)),
                                    d = parseFloat(o.getPropertyValue("margin-" + a));
                                return r ? l[n] + (i ? d : 0) : e[n + 1][u] - A[u]
                            })).map(n.measure).map(r)
                        }
                    }(k, N, t, V, T),
                    L = X.slideSizes,
                    Y = X.slideSizesWithGaps,
                    z = x(k, U, N, P, V, I),
                    O = z.snaps,
                    C = z.snapsAligned,
                    j = -c(O) + c(Y),
                    J = v(R, j, O, C, G).snapsContained,
                    q = !T && "" !== G ? J : C,
                    K = function(A, n, t) {
                        return {
                            limit: function() {
                                var e = n[0],
                                    r = c(n);
                                return l(t ? e - A : r, e)
                            }()
                        }
                    }(j, q, T).limit,
                    _ = d(s(q), D, T),
                    $ = _.clone(),
                    AA = a(t),
                    nA = function(A) {
                        var n = 0;

                        function t(A, t) {
                            return function() {
                                A === !!n && t()
                            }
                        }

                        function e() {
                            n = window.requestAnimationFrame(A)
                        }
                        return {
                            proceed: t(!0, e),
                            start: t(!1, e),
                            stop: t(!0, (function() {
                                window.cancelAnimationFrame(n), n = 0
                            }))
                        }
                    }((function() {
                        T || sA.scrollBounds.constrain(sA.dragHandler.pointerDown()), sA.scrollBody.seek(rA).update();
                        var A = sA.scrollBody.settle(rA);
                        A && !sA.dragHandler.pointerDown() && (sA.animation.stop(), o.emit("settle")), A || o.emit("scroll"), T && (sA.scrollLooper.loop(sA.scrollBody.direction()), sA.slideLooper.loop()), sA.translate.to(eA), sA.animation.proceed()
                    })),
                    tA = q[_.get()],
                    eA = p(tA),
                    rA = p(tA),
                    iA = g(eA, H, 1),
                    oA = b(T, q, j, K, rA),
                    uA = function(A, n, t, e, r, i) {
                        function o(e) {
                            var o = e.distance,
                                u = e.index !== n.get();
                            o && (A.start(), r.add(o)), u && (t.set(n.get()), n.set(e.index), i.emit("select"))
                        }
                        return {
                            distance: function(A, n) {
                                o(e.byDistance(A, n))
                            },
                            index: function(A, t) {
                                var r = n.clone().set(A);
                                o(e.byIndex(r.get(), t))
                            }
                        }
                    }(nA, _, $, oA, rA, o),
                    aA = function(A, n, t, e, r, i, o) {
                        var u = r.removeOffset,
                            a = r.constrain,
                            c = Math.min(Math.max(o, .01), .99),
                            s = i ? [0, n, -n] : [0],
                            l = d(s, c);

                        function d(n, r) {
                            var i = n || s,
                                o = r || 0,
                                u = t.map((function(A) {
                                    return A * o
                                }));
                            return i.reduce((function(n, r) {
                                var i = e.map((function(n, e) {
                                    return {
                                        start: n - t[e] + u[e] + r,
                                        end: n + A - u[e] + r,
                                        index: e
                                    }
                                }));
                                return n.concat(i)
                            }), [])
                        }
                        return {
                            check: function(A, n) {
                                var t = i ? u(A) : a(A);
                                return (n || l).reduce((function(A, n) {
                                    var e = n.index,
                                        r = n.start,
                                        i = n.end;
                                    return -1 === A.indexOf(e) && r < t && i > t ? A.concat([e]) : A
                                }), [])
                            },
                            findSlideBounds: d
                        }
                    }(R, j, L, O, K, T, Z),
                    cA = m(k, W, A, rA, Q, function(A, n) {
                        var t, e;

                        function i(A) {
                            return "undefined" != typeof TouchEvent && A instanceof TouchEvent
                        }

                        function o(A) {
                            return A.timeStamp
                        }

                        function u(n, t) {
                            var e = "client" + ("x" === (t || A.scroll) ? "X" : "Y");
                            return (i(n) ? n.touches[0] : n)[e]
                        }
                        return {
                            isTouchEvent: i,
                            pointerDown: function(A) {
                                return t = A, e = A, n.measure(u(A))
                            },
                            pointerMove: function(A) {
                                var r = u(A) - u(e),
                                    i = o(A) - o(t) > 170;
                                return e = A, i && (t = A), n.measure(r)
                            },
                            pointerUp: function(A) {
                                if (!t || !e) return 0;
                                var i = u(e) - u(t),
                                    a = o(A) - o(t),
                                    c = o(A) - o(e) > 170,
                                    s = i / a;
                                return a && !c && r(s) > .1 ? n.measure(s) : 0
                            },
                            readPoint: u
                        }
                    }(k, N), eA, nA, uA, iA, oA, _, o, T, F),
                    sA = {
                        containerRect: P,
                        slideRects: V,
                        animation: nA,
                        axis: k,
                        direction: W,
                        dragHandler: cA,
                        eventStore: f(),
                        pxToPercent: N,
                        index: _,
                        indexPrevious: $,
                        limit: K,
                        location: eA,
                        options: i,
                        scrollBody: iA,
                        scrollBounds: h(K, eA, rA, iA),
                        scrollLooper: B(j, N, K, eA, [eA, rA]),
                        scrollProgress: w(K),
                        scrollSnaps: q,
                        scrollTarget: oA,
                        scrollTo: uA,
                        slideLooper: y(k, R, j, Y, q, aA, eA, t),
                        slidesInView: aA,
                        slideIndexes: AA,
                        target: rA,
                        translate: E(k, W, n)
                    };
                return sA
            }
            t.d(n, {
                Z: () => Z
            });
            var S = {
                align: "center",
                axis: "x",
                containScroll: "",
                direction: "ltr",
                dragFree: !1,
                draggable: !0,
                inViewThreshold: 0,
                loop: !1,
                skipSnaps: !1,
                slidesToScroll: 1,
                speed: 10,
                startIndex: 0
            };

            function D(A, n, t) {
                var e, r, i, o, u, a, c = function() {
                        var A = {};

                        function n(n) {
                            return A[n] || []
                        }
                        var t = {
                            emit: function(A) {
                                return n(A).forEach((function(n) {
                                    return n(A)
                                })), t
                            },
                            off: function(e, r) {
                                return A[e] = n(e).filter((function(A) {
                                    return A !== r
                                })), t
                            },
                            on: function(e, r) {
                                return A[e] = n(e).concat([r]), t
                            }
                        };
                        return t
                    }(),
                    s = function(A, n) {
                        var t = 0;
                        return function() {
                            window.clearTimeout(t), t = window.setTimeout(A, n) || 0
                        }
                    }((function() {
                        if (!p) return;
                        var A = e.axis.measureSize(o.getBoundingClientRect());
                        h !== A && w();
                        c.emit("resize")
                    }), 500),
                    l = w,
                    d = c.on,
                    f = c.off,
                    p = !1,
                    m = Object.assign({}, S, D.globalOptions),
                    g = Object.assign({}, m),
                    h = 0;

                function v() {
                    var n = "container" in A && A.container,
                        t = "slides" in A && A.slides;
                    o = "root" in A ? A.root : A, u = n || o.children[0], a = t || [].slice.call(u.children), r = function(A) {
                        var n = getComputedStyle(A, ":before").content;
                        return {
                            get: function() {
                                try {
                                    return JSON.parse(n.slice(1, -1).replace(/\\/g, ""))
                                } catch (A) {}
                                return {}
                            }
                        }
                    }(o)
                }

                function B(A, n) {
                    if (v(), m = Object.assign({}, m, A), g = Object.assign({}, m, r.get()), i = Object.assign([], n), (e = M(o, u, a, g, c)).eventStore.add(window, "resize", s), e.translate.to(e.location), h = e.axis.measureSize(o.getBoundingClientRect()), i.forEach((function(A) {
                            return A.init(Z)
                        })), g.loop) {
                        if (!e.slideLooper.canLoop()) return x(), B({
                            loop: !1
                        }, n);
                        e.slideLooper.loop()
                    }
                    g.draggable && u.offsetParent && a.length && e.dragHandler.addActivationEvents(), p || (setTimeout((function() {
                        return c.emit("init")
                    }), 0), p = !0)
                }

                function w(A, n) {
                    if (p) {
                        var t = E(),
                            e = Object.assign({
                                startIndex: t
                            }, A);
                        x(), B(e, n || i), c.emit("reInit")
                    }
                }

                function x() {
                    e.dragHandler.removeAllEvents(), e.animation.stop(), e.eventStore.removeAll(), e.translate.clear(), e.slideLooper.clear(), i.forEach((function(A) {
                        return A.destroy()
                    }))
                }

                function b(A) {
                    var n = e[A ? "target" : "location"].get(),
                        t = g.loop ? "removeOffset" : "constrain";
                    return e.slidesInView.check(e.limit[t](n))
                }

                function y(A, n, t) {
                    e.scrollBody.useBaseMass().useSpeed(n ? 100 : g.speed), p && e.scrollTo.index(A, t || 0)
                }

                function E() {
                    return e.index.get()
                }
                var Z = {
                    canScrollNext: function() {
                        return e.index.clone().add(1).get() !== E()
                    },
                    canScrollPrev: function() {
                        return e.index.clone().add(-1).get() !== E()
                    },
                    clickAllowed: function() {
                        return e.dragHandler.clickAllowed()
                    },
                    containerNode: function() {
                        return u
                    },
                    internalEngine: function() {
                        return e
                    },
                    destroy: function() {
                        p && (x(), p = !1, c.emit("destroy"))
                    },
                    off: f,
                    on: d,
                    previousScrollSnap: function() {
                        return e.indexPrevious.get()
                    },
                    reInit: l,
                    rootNode: function() {
                        return o
                    },
                    scrollNext: function(A) {
                        y(e.index.clone().add(1).get(), !0 === A, -1)
                    },
                    scrollPrev: function(A) {
                        y(e.index.clone().add(-1).get(), !0 === A, 1)
                    },
                    scrollProgress: function() {
                        return e.scrollProgress.get(e.location.get())
                    },
                    scrollSnapList: function() {
                        return e.scrollSnaps.map(e.scrollProgress.get)
                    },
                    scrollTo: y,
                    selectedScrollSnap: E,
                    slideNodes: function() {
                        return a
                    },
                    slidesInView: b,
                    slidesNotInView: function(A) {
                        var n = b(A);
                        return e.slideIndexes.filter((function(A) {
                            return -1 === n.indexOf(A)
                        }))
                    }
                };
                return B(n, t), Z
            }
            D.globalOptions = void 0;
            const Z = D
        },
        5703: (A, n, t) => {
            t.r(n), t.d(n, {
                Slider: () => s
            });
            var e = t(2539),
                r = {
                    destroyHeight: "auto"
                };

            function i(A) {
                var n, t = Object.assign({}, r, i.globalOptions, A),
                    e = t.destroyHeight,
                    o = ["select", "pointerUp"],
                    u = [],
                    a = [];

                function c(A) {
                    var t = "destroy" === A ? e : function() {
                        var A = n.internalEngine(),
                            t = A.slidesInView,
                            e = A.target;
                        return t.check(e.get(), u).map((function(A) {
                            return a[A]
                        })).reduce((function(A, n) {
                            return Math.max(A, n)
                        }), 0)
                    }() + "px";
                    n.containerNode().style.height = t
                }
                var s = {
                    name: "AutoHeight",
                    options: t,
                    init: function(A) {
                        var t = (n = A).internalEngine(),
                            e = t.options,
                            r = t.slidesInView,
                            i = t.slideRects;
                        "y" !== e.axis && (u = r.findSlideBounds(void 0, .5), a = i.map((function(A) {
                            return A.height
                        })), o.forEach((function(A) {
                            return n.on(A, c)
                        })), c())
                    },
                    destroy: function() {
                        o.forEach((function(A) {
                            return n.off(A, c)
                        })), c("destroy")
                    }
                };
                return s
            }
            i.globalOptions = void 0;
            const o = i;
            var u = t(4412),
                a = t(2673),
                c = t(2908);
            class s {
                constructor(A, n) {
                    this.element = void 0, this.props = void 0, this.embla = void 0, this.isListening = !1, this.listen = A => {
                        if (this.isListening) return;
                        this.isListening = !0;
                        const n = matchMedia(A);
                        n.matches && this.setup(), n.addEventListener("change", (({
                            matches: A
                        }) => {
                            A ? this.setup() : this.cleanUp()
                        }))
                    }, this.setup = (A = ".js-slider-viewport") => {
                        const n = (0, u.U2)(A, this.element) || this.element;
                        if (!this.props.defer && n.scrollWidth <= n.clientWidth) return;
                        const r = [];
                        this.props.autoHeight && r.push(o()), n.classList.add("slider-ready"), requestAnimationFrame((() => {
                            const A = (0, e.Z)(n, {
                                inViewThreshold: 1,
                                containScroll: "keepSnaps",
                                align: this.props.align,
                                loop: this.props.loop,
                                skipSnaps: !0
                            }, r);
                            A.on("destroy", (() => {
                                n.classList.remove("slider-ready")
                            })), this.props.showArrows && t.e(407).then(t.bind(t, 1093)).then((({
                                setupSliderArrows: n
                            }) => n(A, this))), this.props.showDots && t.e(789).then(t.bind(t, 6539)).then((({
                                setupSliderDots: n
                            }) => n(A, this))), this.props.showThumbnails && a.Xf >= 820 && t.e(619).then(t.bind(t, 7456)).then((({
                                setupSliderThumbnails: n
                            }) => n(A, this))), this.props.autoPlay && this.props.autoPlay > 0 && t.e(280).then(t.bind(t, 6461)).then((({
                                setupAutoplay: n
                            }) => n(A, this))), this.props.showProgressBar && t.e(869).then(t.bind(t, 336)).then((({
                                setupSliderProgressBar: n
                            }) => n(A, this))), this.props.tabs && t.e(722).then(t.bind(t, 2032)).then((({
                                setupTabs: n
                            }) => n(A, this))), this.props.defer && (0, c.p)("slider:reInit", this.element, (() => {
                                this.embla?.reInit()
                            })), this.embla = A
                        }))
                    }, this.canScroll = () => this.embla?.canScrollNext() || this.embla?.canScrollPrev(), this.cleanUp = () => {
                        this.embla && this.embla.destroy()
                    }, this.element = A, this.props = n;
                    const {
                        enabled: r
                    } = this.props;
                    !0 === r ? this.setup() : "string" == typeof r && this.listen(r)
                }
            }
        },
        2908: (A, n, t) => {
            function e(A, n, t, e) {
                return n || (n = document), n.addEventListener(A, t, e), () => n.removeEventListener(A, t, e)
            }
            t.d(n, {
                p: () => e
            })
        },
        2673: (A, n, t) => {
            t.d(n, {
                V: () => i,
                Xf: () => e,
                ad: () => r
            });
            const e = window.innerWidth,
                r = A => {
                    const n = sessionStorage.getItem("supportVideoAutoplay");
                    if (null != n) A("true" === n);
                    else {
                        let n = !1;
                        const t = document.createElement("video");
                        t.autoplay = !0, t.muted = !0, t.playsInline = !0, t.src = "data:video/mp4;base64,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", t.load(), t.style.display = "none", t.play(), t.onplay = () => {
                            n = !0
                        }, t.oncanplay = () => {
                            sessionStorage.setItem("supportVideoAutoplay", `${n}`), A(n)
                        }
                    }
                },
                i = new Promise((A => r((n => A(n)))))
        }
    }
]);